import { useEventListener } from './useEventListener';
export function useDocumentListener(type, userListener, options) {
    return useEventListener((typeof document !== 'undefined' ? document : null), type, userListener, options);
}
//# sourceMappingURL=useDocumentListener.js.map